// Конфигурация функций приложения
export const FEATURES = {
	// Включить/отключить загрузку комментариев для Ozon отзывов
	OZON_COMMENTS_ENABLED: true,

	// Включить/отключить чат-интерфейс для Ozon
	OZON_CHAT_UI_ENABLED: true,

	// Дебаг режим для логирования комментариев
	DEBUG_COMMENTS: false,
} as const;

// Утилита для проверки включена ли функция
export const isFeatureEnabled = (feature: keyof typeof FEATURES): boolean => {
	return FEATURES[feature];
}; 